import { Body, Button, colors, Image, Spacer } from '@spritz-finance/ui'
import { useNavigate } from 'react-router-dom'
import { Column } from '../../../../components/Layout/Column'
import { ThemedHeroImage } from '../../../../components/ThemedHeroImage'

export const NoPaymentHistory = () => {
    const navigate = useNavigate()
    return (
        <Column align="center">
            <Spacer height={48} />
            <Body.SmBold size={14} secondary>
                No completed payments yet
            </Body.SmBold>
            <Spacer height={8} />
            <Body.SmBold size={14} color={colors.medGrey}>
                Once a payment settles in your account, it will show up here
            </Body.SmBold>
            <Spacer height={48} />
            <ThemedHeroImage>
                <Image.BillHistory width={300} />
            </ThemedHeroImage>

            <Spacer height={48} />
            <Button.CTA onClick={() => navigate('/bills/main')}>Go to bills</Button.CTA>
        </Column>
    )
}
